// extracted by mini-css-extract-plugin
export var footer = "_s6-0";
export var inherit = "_s6-1";
export var input = "_s6-2";
export var modalContent = "_s6-3";
export var quillEditor = "_s6-4";
export var subtitle = "_s6-5";